import {apiInstance} from "../api";

const route = '/links';

// «Генератор ссылок»: links, their funnel from Metrika, the sites links lead to
export class LinksService {
  static fetchAll() {
    return apiInstance.get(route);
  }

  static create(link) {
    return apiInstance.post(route, link);
  }

  static update(id, values) {
    return apiInstance.put(`${route}/${id}`, values);
  }

  // a link as the manager has it: which site and page it is
  static resolve(url) {
    return apiInstance.post(`${route}/resolve`, {url});
  }

  static fetchStats(id, refresh = false) {
    return apiInstance.get(`${route}/${id}/stats`, {params: refresh ? {refresh: 1} : {}});
  }

  // who came by the link (agents' names and phones)
  static fetchPeople(id) {
    return apiInstance.get(`${route}/${id}/people`);
  }

  static fetchDomains() {
    return apiInstance.get(`${route}/domains`);
  }

  static saveDomain(id, domain) {
    return id ? apiInstance.put(`${route}/domains/${id}`, domain) : apiInstance.post(`${route}/domains`, domain);
  }

  static removeDomain(id) {
    return apiInstance.delete(`${route}/domains/${id}`);
  }

  static fetchCounters() {
    return apiInstance.get(`${route}/metrika/counters`);
  }

  static fetchGoals(counterId) {
    return apiInstance.get(`${route}/metrika/counters/${counterId}/goals`);
  }
}
